var topojson = require('topojson');
/**
 * 
 * @param {*} parsedTopojson 
 */
export default function convertTopojsonToGeojson(parsedTopojson) {
  var geojson = new GeoJSON({

  });
  T.each(parsedTopojson.objects, val => {
    geojson.merge(topojson.feature(parsedTopojson, val))
  })
  return geojson.getData();
};
/**
 * 
 */
function GeoJSON() {
  this.merge = function (input) {
    if (this.data == null) {
      this.data = input;
      return;
    }

    var type = this.data.type;
    switch (type) {
      case "FeatureCollection":
        this.data.features = this.data.features.concat(this.getFeatures(input));
        break;
      case "Feature":
        // we need to create a new FeatureCollection & then concatenate the input
        var ob = {
          "type": "FeatureCollection",
          "features": [this.data]
        };
        //now set the data to this new FeatureCollection
        this.data = ob;
        this.data.features = this.data.features.concat(this.getFeatures(input));
        break;
        //For the 7 types of Geometry objects, We need to make the FeatureCollection & then concatenate
      case "Point":
      case "MultiPoint":
      case "LineString":
      case "MultiLineString":
      case "Polygon":
      case "MultiPolygon":
      case "GeometryCollection":
        var ob = {
          "type": "FeatureCollection",
          "features": this.getFeatures(this.data)
        };
        this.data = ob;
        this.data.features = this.data.features.concat(this.getFeatures(input));
        break;
      default:
        //UnExpected data type
        throw "UnExpected data type";
    }
  };
  this.getFeatures = function (geoJSON) {
    var type = geoJSON.type;
    switch (type) {
      case "FeatureCollection":
        return geoJSON.features;
      case "Feature":
        return [geoJSON];
        //For the 7 types of Geometry objects, just fall through to makeFeaturesArray object
      case "Point":
      case "MultiPoint":
      case "LineString":
      case "MultiLineString":
      case "Polygon":
      case "MultiPolygon":
      case "GeometryCollection":
        return this.makeFeaturesArray(geoJSON);
      default:
        //UnExpected Input; Return Empty Array
        return [];
    }
  };
  this.makeFeaturesArray = function (geom) {
    var feature = {
      "type": "Feature",
      "geometry": geom //Note: There can't be properties.
    };
    return [feature];
  };
  this.getData = function () {
    return this.data;
  };
}



// WEBPACK FOOTER //
// ./src/utils/topojson.js